import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Tone } from 'components/DocRightRail/screens/AIAssistant/ToneSelect'
import { GenericSingleChipPicker } from '../components/GenericSingleChipPicker'
import { RevisionLevel, RevisionType } from '../Types'
import Styles from '../BlazeCommandLine.module.scss'
import { RevisionSelection } from '../api/createRevisionRequest'
import { Heading } from 'almanac-ui/Heading/Heading'
import { VoicesAndTonesSelect } from 'components/DocRightRail/screens/AIAssistant/VoicesAndTonesSelect'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { AlmanacEditorState } from 'stores/EditorState'
import { Selection } from 'hooks/queries/layers/revisions/useCreateRevision'

interface Props {
  articleId: string
  layerId: string
  selection?: RevisionSelection
  almanacEditorState?: AlmanacEditorState
  previousRevisionId?: string
}

export const ChangeToneModal = observer(function ChangeToneModal({
  articleId,
  layerId,
  selection,
  almanacEditorState,
  previousRevisionId,
}: Props) {
  const { closeAllModals, closeModal } = useModals()
  const [tones, setSelectedTones] = useState<Tone[]>([])
  const [voice, setSelectedVoice] = useState<number>()
  const [revisionLevel, setRevisionLevel] = useState<RevisionLevel>(RevisionLevel.LIGHT)

  return (
    <Modal.Root aria-labelledby="edit-tone-header">
      <Modal.Header title="Edit Tone" id="edit-tone-header" />

      <Modal.Content>
        <div className={Styles.section}>
          <Heading level={4}>Select your brand voice</Heading>
          <VoicesAndTonesSelect
            className={Styles.voicesAndTones}
            onVoicesChange={setSelectedVoice}
            onTonesChange={setSelectedTones}
            selectedVoice={voice}
            selectedTones={tones}
            isVoicesInline
            isTonesInline
          />
        </div>

        <div className={Styles.section}>
          <Heading level={4}>What level of revisions would you like?</Heading>
          <div>
            <GenericSingleChipPicker
              selectedValue={revisionLevel}
              onChange={setRevisionLevel}
              allValues={Object.values(RevisionLevel)}
            />
          </div>
        </div>
      </Modal.Content>

      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={closeModal}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.buttonGroup} id="doc-generation-modal-generate">
            {almanacEditorState && selection && (
              <ReviseButton
                selection={selection as Selection}
                almanacEditorState={almanacEditorState}
                articleId={articleId}
                layerId={layerId}
                prompt={{
                  revision_type: RevisionType.CHANGE_TONE,
                  brand_voice_id: voice,
                  tone: tones,
                  revision_level: revisionLevel,
                }}
                onRevise={closeAllModals}
                previousRevisionId={previousRevisionId}
              />
            )}
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
})
